<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="header">
              <h4 class="title">Sales Management</h4>
              <p class="category">Manage your sales, orders, and revenue</p>
            </div>
            <div class="content">
              <p>Sales management tools and reports will be located here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesManagement'
}
</script>

<style scoped>
.content {
  padding: 30px 15px;
}
</style>
